// extracted by mini-css-extract-plugin
module.exports = {"addLaneButton":"KanbanBoard_addLaneButton__3YSju","card":"KanbanBoard_card__2f-Ek"};